import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// CRM básico (PRODUCT_VISION cap. 7). Cada cliente pertenece a un negocio.
export async function obtenerClientes() {
  const { data, error } = await supabase
    .from('clientes')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('nombre', { ascending: true });
  if (error) throw error;
  return data || [];
}

// esLocal=true → cliente de mi ciudad; false → de otra ciudad (ciudad = nombre).
// Limpia un arreglo de textos (sin vacíos ni duplicados). Devuelve null si queda vacío.
function listaLimpia(arr) {
  if (!Array.isArray(arr)) return null;
  const out = [...new Set(arr.map((x) => (x || '').trim()).filter(Boolean))];
  return out.length ? out : null;
}

export async function crearCliente({ nombre, telefono, email, notas, esLocal = true, ciudad, destinos, servicios, fechaUltimaCompra }) {
  const local = esLocal !== false;
  const { data, error } = await supabase
    .from('clientes')
    .insert([{
      negocio_id: getNegocioId(),
      nombre: nombre.trim(),
      telefono: telefono?.trim() || null,
      email: email?.trim() || null,
      notas: notas?.trim() || null,
      es_local: local,
      ciudad: local ? null : (ciudad?.trim() || null),
      destinos: listaLimpia(destinos),
      servicios: listaLimpia(servicios),
      fecha_ultima_compra: fechaUltimaCompra || null,
    }])
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function actualizarCliente(id, { nombre, telefono, email, notas, esLocal = true, ciudad, destinos, servicios, fechaUltimaCompra }) {
  const local = esLocal !== false;
  const { error } = await supabase
    .from('clientes')
    .update({
      nombre: nombre.trim(),
      telefono: telefono?.trim() || null,
      email: email?.trim() || null,
      notas: notas?.trim() || null,
      es_local: local,
      ciudad: local ? null : (ciudad?.trim() || null),
      destinos: listaLimpia(destinos),
      servicios: listaLimpia(servicios),
      fecha_ultima_compra: fechaUltimaCompra || null,
    })
    .eq('id', id);
  if (error) throw error;
}

export async function eliminarCliente(id) {
  const { error } = await supabase.from('clientes').delete().eq('id', id);
  if (error) throw error;
}

// Ventas con cliente (para el CRM): producto, fecha y total. Se pagina de 1000
// en 1000 porque la API corta en 1000 filas por consulta.
export async function obtenerVentasDeClientes() {
  const neg = getNegocioId();
  const porPagina = 1000;
  let desde = 0;
  let todas = [];
  let seguir = true;
  while (seguir) {
    const { data, error } = await supabase
      .from('ventas')
      .select('cliente_id, nombre_producto, vendido_en, total')
      .eq('negocio_id', neg)
      .not('cliente_id', 'is', null)
      .order('vendido_en', { ascending: false })
      .range(desde, desde + porPagina - 1);
    if (error) throw error;
    todas = todas.concat(data || []);
    desde += porPagina;
    seguir = (data || []).length === porPagina && desde < 50000;
  }
  return todas;
}

// Historial de compras del cliente (cap. 7.6). Suma total gastado.
export async function obtenerComprasDeCliente(clienteId) {
  const { data, error } = await supabase
    .from('ventas')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .eq('cliente_id', clienteId)
    .order('vendido_en', { ascending: false });
  if (error) throw error;
  return data || [];
}
